import { createTheme } from '@mui/material';

import breakpoints from './breakpoints';
import initializeChartTheme from './chartTheme';
import components from './components';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  components,
  palette,
  shape: {
    borderRadius: 8,
  },
  shadows,
  typography,
  breakpoints,
});

initializeChartTheme();

export default theme;
